import React, { useEffect, useState } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  VStack,
} from "@chakra-ui/react";

export default function DateRangeModal({
  isOpen,
  onClose,
  onApplyDateRange,
  texts,
}) {
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  useEffect(() => {
    if (!isOpen) return;
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    setDateFrom(firstDay.toISOString().split("T")[0]);
    setDateTo(lastDay.toISOString().split("T")[0]);
  }, [isOpen]);

  const handleApply = () => {
    if (!dateFrom || !dateTo) return;
    onApplyDateRange({ date_after: dateFrom, date_before: dateTo });
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="sm">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader p={3}>
          {texts.reports?.selectDateRange || "Select Date Range"}
        </ModalHeader>
        <ModalBody p={3}>
          <VStack spacing={1}>
            <FormControl>
              <FormLabel fontSize="xs">{texts.reports?.fromDate || "From Date"}</FormLabel>
              <Input
                type="date"
                value={dateFrom}
                onChange={(event) => setDateFrom(event.target.value)}
                size="xs"
              />
            </FormControl>
            <FormControl>
              <FormLabel fontSize="xs">{texts.reports?.toDate || "To Date"}</FormLabel>
              <Input
                type="date"
                value={dateTo}
                onChange={(event) => setDateTo(event.target.value)}
                size="xs"
              />
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter p={3}>
          <Button variant="ghost" mr={3} onClick={onClose} size="xs">
            {texts.reports?.cancel || "Cancel"}
          </Button>
          <Button colorScheme="blue" onClick={handleApply} size="xs">
            {texts.reports?.apply || "Apply"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
